import React from 'react';
import { ShowIf } from 'components/utils';
import {msg} from "constants/message";
import {validatable} from 'components/utils';
import { PhoneNumber } from 'base/lib/validate';

class InputNumber extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      isValid: true,
      value: this.props.value
    }
  }

  onChange(e) {
    e.target.value = PhoneNumber(e.target.value);

    if (Number(e.target.value) > 99999) {
      e.target.value = this.state.value;
      this.setState({
        value: e.target.value
      });
    } else {
      this.setState({
        value: e.target.value
      });
    }

    this.props.onChange(e);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.value != nextProps.value) {
      this.setState({
        value: nextProps.value
      });
      if((nextProps.require && nextProps.value != 0) && nextProps.require && nextProps.value != '0') {
        this.setState({
          isValid: true
        });
      }
    }
  }

  classNames() {
    if (this.state.isValid) {
      return 'pt-input';
    } else {
      return 'pt-input pt-intent-danger';
    }
  }

  handleFocus(e) {
    e.target.select();
  }

  nextValue() {
    if (Number(this.state.value) >= 99999) {
      this.setState({
        value: this.state.value
      })
      let e={
        target: {
          value: ''
        }
      };
      e.target.value =  this.state.value;
      this.props.onChange(e);
    } else {
      let value = Number(this.state.value);
      value = value + 1;
      this.setState({
        value: value
      })
      let e={
        target: {
          value: ''
        }
      };
      e.target.value = value;
      this.props.onChange(e);
    }
  }

  prevValue() {
    if (Number(this.state.value) == 0) {
      this.setState({
        value: 0
      })
      let e={
        target: {
          value: ''
        }
      };
      e.target.value =  0;
      this.props.onChange(e);
    } else {
      let value = Number(this.state.value);
      value = value - 1;
      this.setState({
        value: value
      })
      let e={
        target: {
          value: ''
        }
      };
      e.target.value = value;
      this.props.onChange(e);
    }
  }

  validate() {
    if (((this.state.value == 0) ||(typeof this.state.value == 'string' && this.state.value.trim() == '') || (this.props.type == 'sdt' && this.state.value == 0)) && this.props.require) {
      this.setState({
        isValid: false
      });
      this.input.focus();
      return false;
    } else {
      this.setState({
        isValid: true
      });
      return true;
    }
  }

  render() {
    return (
      <div className={this.props.className + ' mb18'}>
        <label className="ip-label">
          { this.props.label }
          <ShowIf condition={this.props.require}>
            <span className="text-required">&nbsp;*</span>
          </ShowIf>
        </label>
        <div className="wrap-input-number">
          <span className="next-value" onClick={this.nextValue.bind(this)}></span>
            <input onFocus={this.handleFocus.bind(this)} type="text" min={0} className={ this.classNames() } ref={(input) => {this.input = input}} value={this.state.value} onChange={ this.onChange.bind(this) } placeholder={this.props.placeholder} name={this.props.name}/>
          <span className="prev-value" onClick={this.prevValue.bind(this)}> </span>
        </div>
        <ShowIf condition={this.props.require && !this.state.isValid}>
          <div className="pt-form-helper-text">{msg.messageDefault}</div>
        </ShowIf>
      </div>
    );
  }
}

InputNumber.defaultProps = {
  className: 'input-group',
  label: '',
  onChange: function() {
    console.log('Need to assign onChange method');
  },
  placeholder: null,
  require: false,
  isValid: false,
  value: 0,
  name: ''
}

export default validatable(InputNumber);



// WEBPACK FOOTER //
// ./src/components/tt-forms/common/InputNumber.jsx